import styled from 'styled-components';

export const TextInputLabel = styled.label`
  display: flex;
  align-items: center;

  font-family: var(--font-sans);
  color: var(--color-black);

  .generic-checkbox {
    margin-right: 8px;
    width: 16px;

    :hover {
      cursor: pointer;
    }
  }
`;
